import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Alert, Button, Modal, Select} from "antd"

const {Option} = Select

class ChangePartnerModal extends Component {
    _handleChangeSelect = (value) => {
        const {onChangePartner} = this.props

        if (typeof onChangePartner === 'function') {
            onChangePartner(value)
        }
    }

    render() {
        const {isOpen, onClose, listPartners, partnerID, loading, error, isUpdated, onUpdatePartner, errorUpdate} = this.props

        return (
            <div className='ChangePartnerModal'>
                <Modal
                    title="Thay đổi đối tác"
                    visible={isOpen}
                    onCancel={onClose}
                    footer={[
                        <div key='select' className='d-flex justify-content-between align-items-center'>
                            <Button key="back" onClick={onClose}>
                                Hủy
                            </Button>
                            <Button key="submit" type="primary" disabled={!isUpdated} loading={loading}
                                    onClick={onUpdatePartner}>
                                Thay đổi
                            </Button>
                        </div>
                    ]}
                >
                    <div>
                        <label>Chọn đối tác mới</label>
                        <Select 
                            value={partnerID} 
                            onChange={this._handleChangeSelect}
                            dropdownClassName='custom-select-partner'
                        >
                            {
                                listPartners.length > 0 && listPartners.map((item) =>
                                    <Option key={item._id} value={item._id}>{item.name}</Option>
                                )
                            }
                        </Select>

                        {error && <Alert message={error} type='error' className='mt-3'/>}
                        {errorUpdate && <Alert message={errorUpdate} type='error' className='mt-3'/>}
                    </div>
                </Modal>
            </div>
        )
    }
}

ChangePartnerModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    listPartners: PropTypes.array.isRequired,
    partnerID: PropTypes.string,
    loading: PropTypes.bool,
    error: PropTypes.string,
    isUpdated: PropTypes.bool,
    onUpdatePartner: PropTypes.func.isRequired,
    errorUpdate: PropTypes.string
}

export default ChangePartnerModal
